import React, { useState } from 'react';
import Head from 'next/head';
import PageHero from '../layouts/PageHero';
import client from '../apollo-client';
import { GUIDES_PAGE, GUIDES_PAGE_INTERFACE } from '../api/guidesPage';
import Image from 'next/image';
import styled from 'styled-components';
import Adventure from '../components/Reviews/Adventure';
import Newsletter from '../layouts/Newsletter/Newsletter';
import { replaceTripshepherdWithSeeSight } from '../utils/trip-sheppered-text';
interface GuideProps {
  background: boolean;
  reverse: boolean;
}
interface ImageShadow {
  position: string;
}
export async function getStaticProps() {
  const { data } = await client.query<GUIDES_PAGE_INTERFACE>(GUIDES_PAGE);

  return {
    props: {
      guidesPage:
        data?.guidesPage &&
        JSON.parse(
          replaceTripshepherdWithSeeSight(JSON.stringify(data?.guidesPage))
        ),
      headData: {
        metaDescription: data?.guidesPage?.metaDescription,
        title: data?.guidesPage?.pageTitle
      }
    }
  };
}

const StyledImage = styled(Image)<ImageShadow>`
  box-shadow: ${props =>
    props.position === 'right'
      ? '8px -8px 0px -1px #1F2C5B '
      : ' -8px -8px 0px -1px #1F2C5B '};
  border-radius: 0.5rem;
  max-height: 400px;
  min-width: 300px;
  align-self: center;

  @media (max-width: 1000px) {
    min-width: 320px;
    max-height: 350px;
  }
  @media (max-width: 550px) {
    min-width: 380px;
    max-height: 380px;
  }
  @media (max-width: 380px) {
    min-width: 300px;
  }
`;
const GuideCard = styled.div<GuideProps>`
  display: flex;
  gap: 1rem;
  background-color: ${props => (props.background ? '#FAFAFA' : 'inherit')};
  flex-direction: ${props => (props.reverse ? 'row' : 'row-reverse')};
  margin-bottom: 2rem;
  @media (max-width: 1000px) {
    flex-direction: column-reverse;
    align-items: center;
    .text-body {
      width: 380px;
    }
  }
  @media (max-width: 550px) {
    .text-body {
      width: 380px;
    }
  }
  @media (max-width: 380px) {
    .text-body {
      width: 300px;
    }
  }
`;
const SeeMoreButton = styled.button`
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
`;

const Guides = ({ guidesPage, headData }: GUIDES_PAGE_INTERFACE) => {
  const [guidesCount, setGuidesCount] = useState(4);
  return (
    <>
      <Head>
        <meta
          name="og:title"
          content={replaceTripshepherdWithSeeSight(headData?.title)}
        />
        <meta
          name="og:description"
          content={replaceTripshepherdWithSeeSight(headData?.metaDescription)}
        />
        <title>{replaceTripshepherdWithSeeSight(headData?.title)}</title>
        <meta
          name="og:description"
          content={replaceTripshepherdWithSeeSight(headData?.metaDescription)}
        />
        {/* <meta name="viewport" content="width=device-width, initial-scale=1" /> */}
        <meta
          name="og:image"
          content="https://res.cloudinary.com/see-sight-tours/image/upload/w_500/v1582036248/fun-guide-group-photo-2019.jpg"
        />
        <link
          rel="canonical"
          href={replaceTripshepherdWithSeeSight(guidesPage?.canonical)}
        />
      </Head>
      <PageHero
        title={'OUR GUIDES'}
        snippet={'Meet Our Energetic Team'}
        media={
          'https://res.cloudinary.com/see-sight-tours/image/upload/w_1920,h_500/t_header/f_auto,q_auto,/fl_progressive:steep/v1581435096/american-falls-luna-island-rainbow-bridge.webP'
        }
        video={false}
      />
      <div className="pb-16">
        <h2 className="px-[2%]  lg:px-[8%] xl:px-[10%] 2xl:px-[15%] 3xl:px-[20%]  text-lg lg:text-4xl text-center text-[#333333] font-semibold my-8       ">
          Meet Our Guides
        </h2>
        {guidesPage?.guides?.slice(0, guidesCount)?.map((guide, i) => (
          <GuideCard
            key={guide?.guide?.firstName}
            background={i % 2 === 0 ? false : true}
            reverse={i % 2 === 0 ? true : false}
            className="px-[2%]  lg:px-[8%] xl:px-[10%] 2xl:px-[15%] 3xl:px-[20%] py-8 "
          >
            <div className=" text-[#333333]  flex flex-col gap-4  overflow-x-hidden flex-1     ">
              <h2 className="text-base md:text-2xl lg:text-[28px]  font-semibold  ">
                {guide?.guide?.firstName}
              </h2>
              <p className=" text-base xl:text-lg pr-2 ">
                {replaceTripshepherdWithSeeSight(guide?.guide?.biography)}
              </p>
            </div>
            <StyledImage
              src={guide?.guide?.professional[0]?.url}
              width={300}
              height={350}
              quality={100}
              position={i % 2 === 0 ? 'right' : 'left'}
              alt={guide?.guide?.firstName}
            />
          </GuideCard>
        ))}
        <div className="flex px-[2%]  lg:px-[8%] xl:px-[10%] 2xl:px-[15%] 3xl:px-[20%] justify-end">
          <SeeMoreButton
            className=" px-10 text-center  text-[#6D6D6D] cursor-pointer  h-14 "
            onClick={() => {
              guidesCount === 4
                ? setGuidesCount(guidesPage?.guides?.length)
                : setGuidesCount(4);
            }}
          >
            {guidesCount === 4 ? `See More ` : 'See Less'}
          </SeeMoreButton>
        </div>
        <Adventure />
        <Newsletter />
      </div>
    </>
  );
};

export default Guides;
